import { Link } from 'react-router-dom';
import { useReceipts } from '@/hooks/queries';
import { useAuth } from '@/hooks/useAuth';
import { formatNumber } from '@/lib/format';

/** A aba da página de comprovantes guardada no navegador — a mesma chave da página. */
export const RECEIPTS_TAB_KEY = 'painel.comprovantes.aba';

/** Estado da navegação que abre os comprovantes nos depósitos sem tipo, de todo o período. */
export interface PendingDepositsState {
  pendingDeposits: true;
}

interface PendingDepositsAlertProps {
  /** Na página de comprovantes, o botão troca de aba; fora dela, leva até lá. */
  onShow?: () => void;
}

/**
 * Os depósitos sem tipo ficam pendentes até alguém dizer se foram de
 * boas-vindas ou de evento. O membro vê os dele; o administrador, os de todos.
 * Some quando não há nenhum.
 */
export function PendingDepositsAlert({ onShow }: PendingDepositsAlertProps) {
  const { isAdmin } = useAuth();
  const { data } = useReceipts({ leverageType: 'DEPOSIT', period: 'all', page: 1, pageSize: 1 });
  const count = data?.total ?? 0;
  if (count === 0) return null;

  const what = count === 1 ? 'depósito está sem tipo' : 'depósitos estão sem tipo';
  const whose = isAdmin ? 'Na operação' : 'Você tem pendente:';
  const action = 'Ver e escolher';

  return (
    <div className="alert alert-warning pending-deposits" role="status">
      <span>
        {whose} <strong className="num">{formatNumber(count)}</strong> {what}. Abra cada um e diga se foi de{' '}
        <strong>boas-vindas</strong> ou de <strong>evento</strong>.
      </span>
      {onShow ? (
        <button type="button" className="btn btn-sm" onClick={onShow}>{action}</button>
      ) : (
        <Link to="/comprovantes" state={{ pendingDeposits: true } satisfies PendingDepositsState} className="btn btn-sm">
          {action}
        </Link>
      )}
    </div>
  );
}
